import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { IReturnUnitsFromScrapsDto } from "./types";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  IReturnUnitsFromScrapsDto
>("stores.warehouses.returnUnitsFromScraps");

export const returnUnitsFromScraps = {
  ...postApis,
};
